import React from 'react';
import UserForm from './UserForm';
import { Formik } from 'formik';
import { API } from 'aws-amplify';

class NewUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            submitted: false,
            newUser: {
                email: "",
                clientId: "",
                clients: null,
                reports: []
            }
        }

        const { handler } = props;

        const listenToLookerFrame = function (event) {
            if (document.getElementById("looker") && event.source === document.getElementById("looker").contentWindow) {
                if (event.origin === "https://haymarket.looker.com" || 
                    event.origin === "https://looker.mycme.com") {
                    console.log('iframe data');
                    console.log(JSON.parse(event.data));

                    window.removeEventListener("message", listenToLookerFrame, false);

                    handler();
                }
            }
        }

        window.addEventListener("message", listenToLookerFrame);
    }

    componentDidMount = () => {
        (async () => {
            const initValues = this.state.newUser;
            initValues.clients = await API.get('lookersso', '/clients', {});
            this.setState({ newUser : initValues});
        })();
    }

    onSubmit = async (values) => {

        values.domain = window.location.origin;

        const apiName = 'lookersso';
        const path = '/users';
        const myInit = {
            body: values
        };

        const response = await API.post(apiName, path, myInit);

        this.setState({
            submitted: true,
            embed: "https://" + response.tempEmbedUrl
        });

    }

    render(){
        if(this.state.newUser.clients){
            return (
                <div>
                    { this.state.submitted ? <iframe id="looker" title="dashboard" src={this.state.embed} width="1" height="1"></iframe> : "" }
                    <h1>Enter the email and clientid</h1>
                    <Formik
                        initialValues={this.state.newUser}
                        onSubmit={this.onSubmit}
                        render={UserForm}
                    />
                    <button onClick={() => this.props.handler()}>(x) Close</button>
                </div>
            );

        }

        return <div>Loading...</div>
    }
}

export default NewUser;

